import { z } from 'zod'

const envSchema = z.object({
  VITE_API_BASE: z.string().url(),
  VITE_PASSPORT_ISSUER: z.string().url(),
  VITE_LOBBY_ORIGIN: z.string().url(),
  VITE_OIDC_CLIENT_ID: z.literal('lobby'),
  VITE_OIDC_SCOPE: z.string().default('openid profile email offline_access'),
  VITE_LOGO_DEV_TOKEN: z.string().min(1),
  /**
   * Optional override for the tenant app URL template (see lib/tenantAppUrl).
   * `{subdomain}` is substituted, e.g. `http://{subdomain}.localhost:4300`.
   * Left unset — the normal case — the per-environment default applies.
   */
  VITE_TENANT_APP_URL: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_APP_ENV: z.enum(['development', 'staging', 'uat', 'production']),
  VITE_DEGRADED_MODE: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
})

export const env = envSchema.parse(import.meta.env)
